<template>
    <v-dialog v-model="dialog" max-width="600px" max-height="600px">
        <template v-slot:activator="{ on }">
            <div class="activator-wrapper">
                <v-btn class="submit-button block" v-on="on" v-if="!hideButton">Новая заявка</v-btn>
            </div>
        </template>
        <v-card class="pa-4">
            <div class="dialog-cross" @click="dialog=false"><img src="/svg/cross.svg"/></div>
            <v-card-text class="products-container">
                <!-- Добавлен класс для динамического выравнивания -->
                <div class="products-grid" :class="{'single-column': !showBankingProducts}">
                    <!-- Колонка страховых продуктов -->
                    <div class="product-column">
                        <div class="product-header">Банковские продукты</div>
                        <div class="products-list">
                            <div v-for="(link, key) in links" :key="key" class="product-item">
                                <!-- Убрано растягивание через block -->
                                <button class="submit-button dialog-button" @click="openLink(link.link)">
                                    {{ link.name }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Колонка банковских продуктов -->
                    <div class="product-column" v-if="showBankingProducts">
                        <div class="product-header">Банковские продукты</div>
                        <div class="products-list">
                            <div class="product-item">
                                <v-btn class="submit-button submit-button-dialog"
                                    href="/bp/new"
                                    target="_blank"
                                >
                                    Новая заявка
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'BankProductsTypeDialogButton',
    props: {
        links: {
            type: Array,
            default: []
        },
        toDisplay: {
            type: Boolean,
            default: false
        },
        hideButton: {
            type: Boolean,
            default: false
        },
        showBankingProducts: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        dialog: false
    }),
    watch: {
        toDisplay: function (value) {
            this.dialog = value
        },
        dialog: function (value) {
            this.$emit('changeDialog', value)
        }
    },
    methods: {
        openLink(link) {
            window.open(link, '_blank');
        }
    },
}
</script>

<style scoped>

.products-grid.single-column {
    justify-content: center; /* Центрируем единственную колонку */
}

.product-column {
    flex: 1;
    min-width: auto; /* Разрешаем уменьшение ширины */
    max-width: 400px; /* Максимальная ширина колонки */
}

/* Убираем растягивание для кнопок внутри диалога */
.submit-button-dialog {
    display: inline-block; /* Изменяем на inline-block */
    /* width: auto !important; Автоматическая ширина */
    padding: 16px 32px !important;
    margin-bottom: 8px;
}

/* Адаптация для мобильных устройств */
@media (max-width: 600px) {
    .products-grid.single-column {
        justify-content: flex-start; /* На мобильных - растягиваем */
    }

    .product-column {
        max-width: 100%; /* На мобильных - полная ширина */
    }

    .submit-button-dialog {
        width: 100% !important; /* На мобильных - полная ширина */
    }
}


.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    font-family: 'SFPro', sans-serif !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.dialog-button {
    height: unset;
    padding: 16px 0 !important;
}

.activator-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
}

.link {
    text-align: center;
    width: 100%;
    color: #00ba57;
    font-family: 'SFPro', sans-serif;
    font-size: 16px;
    transition: opacity 0.3s;
}

.link:hover {
    opacity: 0.8;
}

.submit-button-dialog {
    padding: 16px 32px !important;
    margin-bottom: 8px;
}

.text-center {
    text-align: center;
}

.dialog-headline {
    font-family: 'SFUIDisplay' !important;
    font-size: 32px !important;
    font-weight: bold;
    margin-bottom: 20px;
}

.dialog-cross {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
}
.dialog-cross img{
    max-width: 100%;
    max-height: 100%;
}

/* Стили для новой структуры */
.products-container {
    padding-top: 0 !important;
}

.products-grid {
    display: flex;
    overflow: hidden;
    margin: 0 -16px;
}

.product-column {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
}

.column-divider {
    width: 1px;
    background-color: #eee;
    margin: 8px 0;
}

.product-header {
    font-family: 'SFUIDisplay' !important;
    font-size: 22px !important;
    font-weight: bold;
    text-wrap: nowrap;
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

.products-list {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.product-item {
    margin-bottom: 16px;
    width: 100%;
}


@media (max-width: 960px) {
    .products-grid {
        flex-wrap: wrap;
    }

    .product-column {
        flex: 100%;
        padding: 16px 8px;
    }

    .product-header {
        font-size: 20px !important;
    }
}

@media (max-width: 768px) {
    .dialog-headline {
        font-size: 28px !important;
    }

    .submit-button-dialog {
        padding: 12px 24px !important;
        font-size: 16px !important;
    }
}

@media (max-width: 600px) {
    .v-card {
        padding: 16px !important;
    }

    .dialog-headline {
        font-size: 24px !important;
        margin-bottom: 16px;
    }

    .product-header {
        font-size: 18px !important;
        margin-bottom: 12px;
    }

    .submit-button-dialog {
        padding: 10px 20px !important;
        height: 48px !important;
    }

    .product-item {
        margin-bottom: 12px;
    }
}

@media (max-width: 480px) {
    .dialog-headline {
        font-size: 22px !important;
    }

    .product-header {
        font-size: 16px !important;
    }

    .submit-button {
        font-size: 16px !important;
        height: 56px !important;
    }

    .dialog-button {
        height: unset !important;
    }

    .submit-button-dialog {
        font-size: 14px !important;
        height: 44px !important;
    }

    .activator-wrapper {
        gap: 12px;
    }

    .link {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/BankProductsTypeDialogButton.vue